// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1HourSchema } from './v1/hourSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const stopTimerPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Time entry ID"),
});

export const stopTimerHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Timer stopped
 */
export const stopTimer200Schema = z.lazy(() => v1HourSchema);

/**
 * @description Unauthorized
 */
export const stopTimer401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Time entry not found
 */
export const stopTimer404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const stopTimerMutationResponseSchema = z.lazy(() => stopTimer200Schema);
